import { de as dateFnsLocaleDe } from "date-fns/locale";
import { de as core } from "@xbs/wx-core-locales";
export const de = {
    ...core,
    dateFnsLocale: dateFnsLocaleDe,
    scheduler: {
        "New Event": "Neuer Eintrag",
        "Add description": "Beschreibung",
        "Create event": "Neuer Eintrag",
        "Edit event": "Ändern",
        "Delete event": "Löschen",
        "Event name": "Name",
        "Start date": "Start",
        "End date": "Ende",
        "All day": "Den ganzen Tag",
        "No events": "Keine Ereignisse",
        Type: "Typ",
        Description: "Beschreibung",
        Today: "Heute",
        Day: "Tag",
        Week: "Woche",
        Month: "Monat",
        Year: "Jahr",
        Agenda: "Agenda",
        Calendars: "Kalender",
        hourFormat: "H",
        minuteFormat: "mm",
        monthFormat: "EEE",
        dateFormat: "EEE, d",
        agendaDateFormat: "MMMM d EEEE",
        Color: "Farbe",
        Delete: "Löschen",
        Edit: "Ändern",
        Calendar: "Kalender",
        New: "Neuer",
        Name: "Name",
        Save: "Speichern",
        Add: "Hinzufügen",
        confirmDelete: "Der Eintrag wird gelöscht",
        confirmUnsaved: "Du hast nicht gespeicherte Änderungen! Möchten Sie sie verwerfen?",
    },
};
//# sourceMappingURL=de.js.map